'use client'

import { LayoutBreadcrumbsOverride } from '@/app/layout/MainSiteLayout/LayoutBreadcrumbsOverride'

import { AccessoriesPage } from '@/screens/Accessories'

import { TAccessoryPageData, TPage } from '@/shared/types/deprecated-types'

type Props = {
	accessories: TAccessoryPageData
	breadcrumbs: TPage[]
}

const AccessoriesSlugPageContent = ({ accessories }: { accessories: TAccessoryPageData }) => {
	return <AccessoriesPage accessories={accessories} brands={[]} />
}

export function AccessoriesSlugClient({ accessories, breadcrumbs }: Props) {
	return (
		<>
			<LayoutBreadcrumbsOverride pages={breadcrumbs} />
			<AccessoriesSlugPageContent accessories={accessories} />
		</>
	)
}
